import * as React from "react";
const SvgDeleteConvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15px"
    height="15px"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g
      stroke="#3D3D3D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M20.057 9.467s-.543 6.735-.858 9.572c-.15 1.355-.987 2.149-2.358 2.174-2.61.047-5.221.05-7.83-.005-1.318-.027-2.141-.831-2.288-2.162-.317-2.862-.857-9.58-.857-9.58M21.44 6.238H4.482M18.172 6.239a1.65 1.65 0 0 1-1.615-1.324l-.243-1.216a1.28 1.28 0 0 0-1.237-.949h-4.233a1.28 1.28 0 0 0-1.237.949l-.243 1.216A1.65 1.65 0 0 1 7.75 6.239" />
    </g>
  </svg>
);
export default SvgDeleteConvgIcon;
